"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("./index.js"));
var _index2 = require("../TextInput/index");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTree = require("./StyledTree");
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbUtils = require("ykb-utils");
var _excluded = ["data", "treeData", "containerStyle", "inputProps"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TreeNode = _index.default.TreeNode;
var _getParentKey = function getParentKey(key, tree) {
  var parentKey;
  for (var i = 0; i < tree.length; i++) {
    var node = tree[i];
    if (node.children) {
      if (node.children.some(function (item) {
        return String(item.key) === String(key);
      })) {
        parentKey = node.key;
      } else if (_getParentKey(key, node.children)) {
        parentKey = _getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
var useDebounce = function useDebounce(func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      func.apply(null, args);
    }, delay);
  };
};
var SearchTree = exports.default = /*#__PURE__*/function (_React$Component) {
  function SearchTree() {
    var _this;
    (0, _classCallCheck2.default)(this, SearchTree);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this = _callSuper(this, SearchTree, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      dataList: [],
      expandedKeys: _this.props.defaultExpandedKeys ? _this.props.defaultExpandedKeys : [],
      searchValue: '',
      autoExpandParent: true,
      collapseTree: _this.props.collapseTree
    });
    (0, _defineProperty2.default)(_this, "generateList", function (data, cb) {
      var dataList = _this.state.dataList;
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        var key = node.key;
        var title = node.title;
        dataList.push({
          key: key,
          title: title
        });
        node.children && _this.generateList(node.children, node.key);
      }
      var preparedCb = typeof cb === 'function' ? cb : function () {};
      _this.setState({
        dataList: dataList
      }, preparedCb);
    });
    (0, _defineProperty2.default)(_this, "onExpand", function (expandedKeys, node) {
      _this.setState({
        expandedKeys: expandedKeys,
        autoExpandParent: false
      });
      typeof _this.props.onExpand === 'function' && _this.props.onExpand(expandedKeys, node);
    });
    (0, _defineProperty2.default)(_this, "prepareExpandedKeys", function (e) {
      var _this$state = _this.state,
        collapseTree = _this$state.collapseTree,
        dataList = _this$state.dataList;
      var value = e.target.value;
      var searchValue = value;
      var self = _this;
      var expandedKeys = dataList.map(function (item) {
        if (_this.findIndexByCaseSensitive(item.title, value) > -1) {
          return _getParentKey(item.key, _this.props.data);
        }
        return null;
      }).filter(function (item, i, self) {
        return item && self.indexOf(item) === i;
      });
      var checkedExpandedKey = value.length > 0 ? expandedKeys : [];
      var foundedExpandedKeys = collapseTree ? checkedExpandedKey : expandedKeys;
      _this.setState({
        expandedKeys: foundedExpandedKeys,
        autoExpandParent: true
      });
      typeof _this.props.onSearch === 'function' && _this.props.onSearch(searchValue, foundedExpandedKeys);
    });
    (0, _defineProperty2.default)(_this, "onChange", function (e) {
      var _this$props = _this.props,
        debounce = _this$props.debounce,
        debounceDuration = _this$props.debounceDuration;
      var value = e.target.value;
      var searchValue = value;
      _this.setState({
        searchValue: searchValue
      });
      var prepareExpandedKeys = _this.prepareExpandedKeysDebounce || _this.prepareExpandedKeys;
      if (debounce) {
        prepareExpandedKeys = useDebounce(function (e) {
          _this.prepareExpandedKeys(e);
        }, debounceDuration);
      }
      prepareExpandedKeys(e);
    });
    (0, _defineProperty2.default)(_this, "findIndexByCaseSensitive", function (title, value) {
      var useCaseSensitive = _this.props.caseSensitive;
      if (useCaseSensitive) return title.indexOf(value);
      var titleToLowerCase = title && title.toLowerCase();
      var valueToLowerCase = value && String(value).toLowerCase();
      return titleToLowerCase.indexOf(valueToLowerCase);
    });
    return _this;
  }
  (0, _inherits2.default)(SearchTree, _React$Component);
  return (0, _createClass2.default)(SearchTree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateList(this.props.data);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var _this2 = this;
      var self = this;
      self.setState({
        dataList: []
      });
      self.generateList(props.data, function () {
        if (!(0, _ykbUtils.isNullOrUndefined)(props.searchValue) && props.searchValue !== _this2.state.searchValue) {
          self.setState({
            searchValue: props.searchValue || ''
          });
          self.onChange({
            target: {
              value: props.searchValue || ''
            }
          });
        }
      });

      // sonradan props.expandedKeys değişir ise state.expandedKeys değişkenini günceller
      // bu sayede component render olduktan sonra nodların sonradan açık/kapalı olması sağlanabilir.
      if (props.expandedKeys && props.expandedKeys !== this.state.expandedKeys) {
        self.setState({
          expandedKeys: props.expandedKeys
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state2 = this.state,
        searchValue = _this$state2.searchValue,
        expandedKeys = _this$state2.expandedKeys,
        autoExpandParent = _this$state2.autoExpandParent;
      var _loop = function loop(data) {
        return data.map(function (item) {
          var index = _this3.findIndexByCaseSensitive(item.title, searchValue);
          var beforeStr = item.title.substr(0, index);
          var afterStr = item.title.substr(index + searchValue.length);
          var searchValueLength = searchValue.length;
          var isExistIndex = index > -1;
          var title = isExistIndex ? /*#__PURE__*/_react.default.createElement("span", {
            className: "text"
          }, beforeStr, /*#__PURE__*/_react.default.createElement("span", {
            className: "match"
          }, item.title.substr(index, searchValueLength)), afterStr) : /*#__PURE__*/_react.default.createElement("span", {
            className: "text"
          }, item.title);
          if (item.children) {
            var loopResult = _loop(item.children);
            return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this3.props.notRenderOnUnmatch ? (loopResult.some(function (x) {
              return x.props.children !== false;
            }) || isExistIndex) && /*#__PURE__*/_react.default.createElement(TreeNode, (0, _extends2.default)({}, item, {
              title: title
            }), loopResult) : /*#__PURE__*/_react.default.createElement(TreeNode, (0, _extends2.default)({}, item, {
              title: title
            }), loopResult));
          }
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this3.props.notRenderOnUnmatch ? isExistIndex && /*#__PURE__*/_react.default.createElement(TreeNode, (0, _extends2.default)({}, item, {
            title: title
          })) : /*#__PURE__*/_react.default.createElement(TreeNode, (0, _extends2.default)({}, item, {
            title: title
          })));
        });
      };
      var _this$props2 = this.props,
        data = _this$props2.data,
        treeData = _this$props2.treeData,
        containerStyle = _this$props2.containerStyle,
        inputProps = _this$props2.inputProps,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledTree.StyledSearchTree, {
          theme: theme,
          style: containerStyle
        }, /*#__PURE__*/_react.default.createElement(_index2.TextInput, (0, _extends2.default)({
          placeholder: "Search"
        }, inputProps, {
          onChange: _this3.onChange,
          suffix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
            name: "search"
          }),
          value: searchValue
        })), /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
          className: "search-tree"
        }, rest, {
          expandedKeys: expandedKeys,
          onExpand: _this3.onExpand,
          autoExpandParent: autoExpandParent
        }), _loop(_this3.props.data)));
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(SearchTree, "defaultProps", {
  debounce: false,
  debounceDuration: 500
});
SearchTree.displayName = 'SearchTree';